var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-select", {
    staticClass: "w-100",
    attrs: {
      placeholder: _vm.$t("common.search-by-text", {
        text: _vm.$t("lbl_truck")
      }),
      value: _vm.value,
      options: _vm.options,
      loading: _vm.loading,
      disabled: _vm.disabled,
      "filter-option": false,
      "allow-clear": "",
      "show-search": ""
    },
    on: { search: _vm.onSearch, change: _vm.onChange }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }